import type { SupabaseUserOption } from "./filterCopy";

export type SubscriptionState = "active" | "stripe" | "canceled";

export const STRIPE_GRANT_FREE_PERIOD_STATUSES = ["trialing", "active", "paused"] as const;
export type StripeGrantFreePeriodStatus = (typeof STRIPE_GRANT_FREE_PERIOD_STATUSES)[number];

export interface SubscriptionType {
  name?: string;
}

export interface Subscription {
  id?: string | number;
  type_id?: number;
  type?: SubscriptionType;
  status?: string;
  stripe_id?: string | null;
  last_action?: string | null;
  current_period_start_date?: string | null;
  current_period_end_date?: string | null;
  participant_id?: string | null;
}

export interface SubscriptionContext {
  participant_id?: string | null;
  stripe_customer_id?: string | null;
  stripe_subscription_type_id?: string | null;
  employees_without_subscription: string[];
  can_add_subscription: boolean;
}

export interface SubscriptionsResponse {
  data: Subscription[];
}

export interface SubscriptionContextResponse {
  data: SubscriptionContext;
}

export interface ExtendSubscriptionRequest {
  days: number;
  sub_id?: string;
  type_id?: number;
  stripe_subscription_id?: string;
}

export interface CreateSubscriptionRequest {
  participant_id: string;
  days?: number;
  employee_id?: string;
  callback?: string;
}

export interface PortalSubscriptionRequest {
  customer_id: string;
  callback?: string;
}

export interface SubscriptionActionResponse {
  success: boolean;
  url?: string;
  data?: unknown;
}

export function getSubscriptionState(sub: Subscription): SubscriptionState {
  if (sub.stripe_id != null) return "stripe";
  if (sub.status === "canceled") return "canceled";
  return "active";
}

export function canGrantFreePeriod(sub: Subscription): boolean {
  return (
    sub.stripe_id != null &&
    STRIPE_GRANT_FREE_PERIOD_STATUSES.includes(
      (sub.status ?? "") as StripeGrantFreePeriodStatus,
    )
  );
}

export function canOpenStripePortal(
  sub: Subscription,
  context: SubscriptionContext | null,
): boolean {
  return sub.stripe_id != null && !!context?.stripe_customer_id;
}

export type { SupabaseUserOption };
